import {getAuth, setAuth} from '@infra/api/authManager/authManager';

export const RefreshSession = (): (() => Promise<void>) => {
  return async (): Promise<void> => {
    const token = await getAuth();
    if (token) await setAuth(token);
  };
};
